module.exports = __webpack_public_path__ + "img/hp_wang02.88a408e0.png";